import { ASTERISK_API_BASE } from '../config/bridge';

const AGENT_STATE_ENDPOINT = `${ASTERISK_API_BASE}/agentstate`;

const safeJsonParse = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const resolveStoredContext = () => {
  const storedUser = safeJsonParse(localStorage.getItem('user')) || {};
  const storedExt = safeJsonParse(localStorage.getItem('extension')) || {};

  const agentId =
    storedExt.extensionNumber ||
    storedExt.ExtensionNumber ||
    storedExt.extension_number ||
    storedUser.ExtensionNumber ||
    storedUser.extension ||
    storedUser.UserID ||
    storedUser.userId ||
    '';

  const cmsUserId = storedUser.UserID || storedUser.userId || '';
  const cmsUserName =
    storedUser.FullName ||
    storedUser.UserName ||
    storedUser.LoginName ||
    storedUser.username ||
    storedUser.name ||
    '';

  let direction = '';
  try {
    const storedMode = localStorage.getItem('frontOfficeNew_agentMode');
    direction = storedMode ? String(storedMode).trim().toLowerCase() : '';
  } catch {
    direction = '';
  }

  return { agentId, cmsUserId, cmsUserName, direction };
};

export const buildAgentStatePayload = ({
  status,
  reason,
  inQueue = '0',
  prevStatus = null,
  prevDurationSeconds = null,
  eventTime = new Date(),
  agentId,
  cmsUserId,
  cmsUserName,
  direction
} = {}) => {
  const stored = resolveStoredContext();
  const resolvedAgentId = agentId || stored.agentId || '';
  const resolvedCmsUserId = cmsUserId || stored.cmsUserId || '';
  const resolvedCmsUserName = cmsUserName || stored.cmsUserName || '';
  const resolvedDirection = direction || stored.direction || '';

  if (!status && !resolvedAgentId && !resolvedCmsUserId) return null;

  return {
    eventTime: eventTime instanceof Date ? eventTime.toISOString() : eventTime,
    agentId: resolvedAgentId || null,
    status: status || null,
    reason: reason || null,
    inQueue: inQueue || null,
    direction: resolvedDirection || null,
    cmsUserId: resolvedCmsUserId || null,
    cmsUserName: resolvedCmsUserName || null,
    prevStatus: prevStatus || null,
    prevDurationSeconds: prevDurationSeconds ?? null
  };
};

export const sendAgentStateLog = async (payload) => {
  if (!payload) return false;
  try {
    await fetch(AGENT_STATE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    });
    return true;
  } catch {
    return false;
  }
};

export const sendAgentStateBeacon = (payload) => {
  if (!payload) return false;
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      return navigator.sendBeacon(AGENT_STATE_ENDPOINT, blob);
    }
    fetch(AGENT_STATE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {});
    return true;
  } catch {
    return false;
  }
};
